import { traverseGraph } from "@/utils/stagePageUtils";
import { useMemo } from "react";
import { useDeferredEffect } from "./useDefferedEffect";
import { preloadUrls } from "@/utils/preload";
import { Stage } from "@/types/productTypes";
import { useAdminStore } from "@/store/useAdminStore";

export function useStageImages(
   stage: Stage,
   nextStage: Stage | null | undefined,
   watchedValues: Record<string, any>,
   index: number
) {
   const { optionPairs, getImagesInStage } = useAdminStore();
   // 1) Compute `itemPairImages` via `useMemo`
   const itemPairImages = useMemo(() => {
      if (!stage.optionPairId) return null;
      const optionPair = optionPairs.find(
         (pair: any) => pair.id === stage.optionPairId
      );
      if (!optionPair || !optionPair.graph) return null;

      const rootNodeEntry = Object.values(optionPair.graph).find(
         (node: any) => node.type === "ROOT"
      );
      if (!rootNodeEntry) {
         console.warn("No ROOT node found in graph");
         return [];
      }

      let result = traverseGraph(
         optionPair.graph,
         rootNodeEntry.nodeId,
         watchedValues
      );
      if (result.length === 0) result = [];
      return result;
   }, [stage, watchedValues]);

   // 2) Preload images for current stage & next stage
   useDeferredEffect(async () => {
      if (index === 0 && stage.id) {
         const images = await getImagesInStage(stage.id);
         preloadUrls(images);
      }
      if (!nextStage || !nextStage.id) return;
      const images = await getImagesInStage(nextStage.id);
      preloadUrls(images);
   }, [stage, nextStage, index]);

   return itemPairImages;
}
